@if (openedSubject()) {
  @if (breakpoints().isTablet) {
    <div class="overlay-under-side-and-nav"></div>
  } @else {
    <div class="overlay"></div>
  }
}

@let unreadCount = totalUnreadCount();
<div
  class="wrapper"
  [puDropdownTriggerFor]="notifications"
  alignX="end"
  alignY="bottom"
  [offsetY]="offsetY()"
  [offsetX]="offsetX()"
  [inheritWidth]="false"
  (opened)="showOverlay()">
  @if (unreadCount) {
    <pu-icon size="28" iconName="notifications-unread" />
    @if (breakpoints().isDesktop) {
      <div class="count" [class.big-count]="unreadCount >= 100">
        @if (markAsReadLoading()) {
          <div class="unread-count-loader">
            <pp-spinner class="spinner"></pp-spinner>
          </div>
        } @else {
          {{ unreadCount < 100 ? unreadCount : '99+' }}
        }
      </div>
    }
  } @else {
    <pu-icon size="28" iconName="notifications" />
  }
</div>

<pu-dropdown #notifications [closeOnClick]="false">
  @if (openedSubject()) {
    <pp-notifications-history (closeDropdown)="closeDropdown()" />
  }
</pu-dropdown>

<ng-template #messageToastTpl let-toast let-index="index" let-close="close">
  <pu-toast
    iconName="info"
    closeIconName="close"
    [toastType]="toast.type"
    [title]="toast.title"
    [message]="toast.message"
    [timeout]="toast.timeout"
    (closeToast)="close(index); closeToast($event, toast.entity)" />
</ng-template>

<ng-template #threeDsToastTpl let-toast let-index="index" let-close="close">
  <pp-three-ds-toast
    [message]="toast.entity"
    (closeToast)="close(index); closeToast($event, toast.entity)"
    (markAsRead)="markAsRead(toast.entity)" />
</ng-template>
